import axios from './axios';

export default {
  signOut() {
    return axios.delete('/students/sign_out');
  },
  signIn(payload) {
    return axios.post('/students/sign_in', { student: payload });
  },
  signUp(payload) {
    return axios.post('/students', { student: payload });
  },
  me() {
    return axios.get('/me');
  },
  resetPassword({ password, token }) {
    return axios.put('/students/password', { student: { password, reset_password_token: token } });
  },
  resendConfirmationLink({ email }) {
    return axios.post('/students/confirmation', { student: { email } });
  },
  changePassword({ currentPassword, password }) {
    return axios.put('/students.json', { student: { password, current_password: currentPassword } });
  },
  uploadPicture(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/picture', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  askForPasswordReset({ email }) {
    return axios.post('/students/password', { student: { email } });
  },
};
